import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
  size?: 'normal' | 'large';
}

export default function ComicCard({ comic, size = 'normal' }: ComicCardProps) {
  return (
    <Link
      to={`/comic/${comic.slug}`}
      className="group block cursor-pointer"
    >
      <div className={`relative overflow-hidden rounded-lg bg-background-100 ${size === 'large' ? 'aspect-[3/4]' : 'aspect-[2/3]'}`}>
        <img
          src={comic.coverUrl}
          alt={`${comic.title} - 韩漫网`}
          title={`${comic.title} - 韩漫在线免费阅读`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
        <div className="absolute top-2 right-2">
          {comic.status === '已完结' ? (
            <span className="px-2 py-0.5 text-xs font-medium bg-accent-500 text-background-50 rounded-full whitespace-nowrap">
              {comic.status}
            </span>
          ) : (
            <span className="px-2 py-0.5 text-xs font-medium bg-primary-500 text-background-50 rounded-full whitespace-nowrap">
              {comic.status}
            </span>
          )}
        </div>
        {size === 'large' && (
          <div className="absolute bottom-0 left-0 right-0 p-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
            <p className="text-xs text-white/90 line-clamp-2">{comic.description}</p>
          </div>
        )}
      </div>
      <div className="mt-2.5">
        <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1">
          {comic.title}
        </h3>
        <div className="flex items-center gap-2 mt-1 text-xs text-foreground-500">
          <span>{comic.author}</span>
          <span>·</span>
          <span className="flex items-center gap-0.5">
            <i className="ri-star-fill text-accent-500 w-3 h-3 flex items-center justify-center text-xs"></i>
            {comic.rating}
          </span>
        </div>
        <p className="mt-1 text-xs text-foreground-400">
          更新至{comic.totalChapters}话 · {comic.views >= 10000 ? `${(comic.views / 10000).toFixed(0)}万` : comic.views}次阅读
        </p>
      </div>
    </Link>
  );
}